import { reactive } from 'vue'
export const dragState = reactive({ item: null, clone: null, dropResult: null })